import { TSiblingSiteInformation } from "../../header";
import styles from "./slide-in-menu.module.less";
import { KeyboardEvent, MutableRefObject } from "react";
import { TCategory, TLink } from "../../../../../types/link-types";
import InfoBoxWrapper from "../../../../elements/info-box-wrapper/info-box-wrapper";
import Navigation from "../navigation/navigation";
import InfoBox from "../../../../elements/info-box/info-box";
import { TLanguage, TLanguageLink } from "../../../../../types/language-types";
import LanguageSelection from "../language-selection/language-selection";
import Link from "../../../../elements/link/link";

type TSlideInMenuProps = {
  isOpen: boolean;
  scrollAllowedRef?: MutableRefObject<HTMLDivElement | null>;
  currentLanguage: TLanguage;
  languages: Array<TLanguageLink>;
  popularLinks?: Array<TLink>;
  menuItems: Array<TCategory | TLink>;
  popularLinksHeading?: string;
  siblingSiteInformation: TSiblingSiteInformation;
  portalContainer?: HTMLElement | null;
  currentPageUrl?: string;
  closeMenuFunc: () => void;
  masterLanguage?: string;
};

export const SlideInMenu = ({
  isOpen,
  scrollAllowedRef,
  popularLinks,
  menuItems,
  popularLinksHeading,
  siblingSiteInformation,
  currentLanguage,
  languages,
  currentPageUrl,
  masterLanguage,
  closeMenuFunc,
}: TSlideInMenuProps) => {
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      closeMenuFunc();
    }
  };

  const hasSiblingSiteInformation =
    siblingSiteInformation.heading && siblingSiteInformation.link && siblingSiteInformation.text;

  return (
    <nav className={[styles.wrapper, isOpen ? styles.open : ""].join(" ")}>
      <div className={styles.languageSelectionWrapper}>
        <LanguageSelection
          noSeparator={true}
          className={styles.languageSelection}
          languages={languages}
          currentLanguage={currentLanguage}
        />
      </div>
      <div tabIndex={0} className={styles.content} onKeyDown={(event) => onKeyDown(event)}>
        <Navigation
          scrollAllowedRef={scrollAllowedRef}
          currentPageUrl={currentPageUrl}
          closeMenuFunc={closeMenuFunc}
          isOpen={isOpen}
          menuItems={menuItems}
          currentLanguage={currentLanguage}
          masterLanguage={masterLanguage}
        />
        <div className={styles.sideSection}>
          <PopularLinksSection popularLinks={popularLinks} popularLinksHeading={popularLinksHeading} />
          {hasSiblingSiteInformation && <SiblingSiteSection {...siblingSiteInformation} />}
        </div>
      </div>
    </nav>
  );
};

export default SlideInMenu;

type TPopularLinksSectionProps = {
  popularLinks?: Array<TLink>;
  popularLinksHeading?: string;
};

const PopularLinksSection = ({ popularLinks, popularLinksHeading }: TPopularLinksSectionProps) => {
  if (!Array.isArray(popularLinks)) {
    return null;
  }

  return (
    <InfoBoxWrapper>
      {popularLinksHeading && (
        <p className={[styles.popularLinksSectionHeading, "h5"].join(" ")}>{popularLinksHeading}</p>
      )}
      <ul className={styles.list}>
        {popularLinks.map((link) => (
          <li key={link.title} className={styles.popularLinkItem}>
            <Link {...link} className={`body-base ${styles.popularLink}`} />
          </li>
        ))}
      </ul>
    </InfoBoxWrapper>
  );
};

const SiblingSiteSection = ({ heading, text, link }: TSiblingSiteInformation) => {
  return <InfoBox heading={heading} text={text} link={link} />;
};
